(() => {
  if (window.__AVSupportGuardV34) return;
  window.__AVSupportGuardV34 = true;
  const SUPPORT = '/pages/atendimento';
  const normalize = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();

  const repair = (root = document) => {
    const scope = root.matches?.('footer,.shopify-section-group-footer-group') ? root : root.querySelector?.('footer,.shopify-section-group-footer-group');
    if (!scope) return;
    scope.querySelectorAll('a').forEach((link) => {
      const label = normalize(`${link.textContent || ''} ${link.getAttribute('aria-label') || ''}`);
      const supportIntent = link.hasAttribute('data-av-support-page-link') || /(^|\s)(atendimento|suporte|support)(\s|$)/.test(label);
      if (!supportIntent) return;
      if (link.getAttribute('href') !== SUPPORT) link.setAttribute('href', SUPPORT);
      if (link.hasAttribute('target')) link.removeAttribute('target');
      if (link.hasAttribute('rel')) link.removeAttribute('rel');
      if (!link.hasAttribute('data-av-support-page-link')) link.setAttribute('data-av-support-page-link', '');
    });
  };

  const init = () => {
    repair();
    const footer = document.querySelector('footer,.shopify-section-group-footer-group');
    if (!footer) return;
    new MutationObserver(() => repair(footer)).observe(footer, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => repair(event.target));
})();
